import { render, staticRenderFns } from "./ComplaintUser.vue?vue&type=template&id=67781c88&scoped=true"
import script from "./ComplaintUser.vue?vue&type=script&lang=js"
export * from "./ComplaintUser.vue?vue&type=script&lang=js"
import style0 from "./ComplaintUser.vue?vue&type=style&index=0&id=67781c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67781c88",
  null
  
)

export default component.exports